import { darken } from "polished";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Icon from "@/utils/Icon";

const SocialBanner = ({ lang, routeMap }) => {
  return (
    <>
      <SocialBannerWrapper>
        <Title suppressHydrationWarning>{lang?.home.socialbanner.text}</Title>
        <IconsWrapper>
          <li>
            <IconWrapperLink
              className="s-blue"
              to={`${routeMap?.urls[lang?.home.socialbanner.url.Mail]}`}
              aria-label="Newsletter"
            >
              <Icon icon="email" size={24} />
            </IconWrapperLink>
          </li>
          <li>
            <IconWrapper
              className="s-green"
              href={`${
                routeMap?.urls[lang?.home.socialbanner.url.whatsapp] ??
                lang?.home.socialbanner.url.whatsapp
              }`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <Icon icon="whatsapp" size={24} />
            </IconWrapper>
          </li>
          <li>
            <IconWrapper
              className="s-blue"
              href={`${
                routeMap?.urls[lang?.home.socialbanner.url.facebook] ??
                lang?.home.socialbanner.url.facebook
              }`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <Icon icon="facebook" size={24} />
            </IconWrapper>
          </li>
        </IconsWrapper>
      </SocialBannerWrapper>
    </>
  );
};

export default SocialBanner;

const SocialBannerWrapper = styled.div.attrs({
  className: "SocialBannerWrapper",
})`
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.grey};
  min-height: 70px;
  gap: 12px;
  width: 100%;
  flex-direction: column;
  padding: 0 16px;
  @media screen and (min-width: 768px) {
    flex-direction: row;
    padding: 1em 0;
  }
`;

const Title = styled.h3.attrs({
  className: "Title",
})`
  color: ${(props) => props.theme.colors.blue};
  font-size: 2.2rem;
  text-align: center;
  @media screen and (min-width: 768px) {
    text-align: left;
  }
`;

const IconsWrapper = styled.ul.attrs({
  className: "IconsWrapper",
})`
  margin: 0;
  padding: 0;
  flex: 0 1 auto;
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.grey};
  min-height: 70px;
  gap: 12px;
`;

const IconWrapperLink = styled(Link).attrs({
  className: "IconWrapper",
})`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 50px;
  color: white;
  font-size: 3.2rem;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.2s ease;
  &.s-blue {
    background-color: ${(props) => props.theme.colors.blue};
  }
  &.s-green {
    background-color: ${(props) => props.theme.colors.green};
  }
  &.s-blue:hover {
    background-color: ${(props) => darken(0.05, props.theme.colors.blue)};
  }
  &.s-green:hover {
    background-color: ${(props) => darken(0.05, props.theme.colors.green)};
  }

  img {
    display: block;
    height: 15px;
    width: 15px;
  }
`;

const IconWrapper = styled.a.attrs({
  className: "IconWrapper",
})`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 50px;
  color: white;
  font-size: 3.2rem;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.2s ease;
  &.s-blue {
    background-color: ${(props) => props.theme.colors.blue};
  }
  &.s-green {
    background-color: ${(props) => props.theme.colors.green};
  }
  &.s-blue:hover {
    background-color: ${(props) => darken(0.05, props.theme.colors.blue)};
  }
  &.s-green:hover {
    background-color: ${(props) => darken(0.05, props.theme.colors.green)};
  }

  img {
    display: block;
    height: 15px;
    width: 15px;
  }
`;
